import Badge from "@/components/core/badge.tsx";
import DataTable, { type ColumnDef } from "@/components/core/data-table.tsx";
import Pagination from "@/components/core/pagination.tsx";
import { Searchbar } from "@/components/core/searchbar.tsx";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/core/tabs.tsx";
import { Content } from "@/components/layouts/content";
import { Header } from "@/components/layouts/header";
import { formatDate } from "@/utils/format-date.ts";
import { Link, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_dashboard/text-editor")({
	component: Page,
});

import { DocumentEditor } from "@onlyoffice/document-editor-react";
import React, { useState } from "react";

const OnlyOfficeEditor = () => {
	const [content] = useState(""); // Placeholder for your document content

	const config = {
		document: {
			fileType: "docx",
			key: "unique-doc-key",
			// title: "Sample Document.docx",
			// url: "https://sc-admin.revlv.com/sample.docx",
			title: "FORM NO. 3-9-CV (Rule 3, Section 9: Order for Inclusion of Necessary Party)",
			url: "https://sc-admin.revlv.com/forms/judicial/civil-procedure/3-9-CV.docx",
			permissions: {
				chat: false,
				comment: false,
			},
		},
		documentType: "word",
		editorConfig: {
			mode: "edit",
			lang: "en",
			callbackUrl: "https://sc-docserver.revlv.com/callback",
			customization: {
				showFeedback: false, // Hides the feedback button
				chat: false,
				comments: false,
				feedback: false,
				uiTheme: "theme-classic-light",
				hideRightMenu: true,
				showReviewChanges: false,
				toolbarNoTabs: true,
				plugins: false,
				compactToolbar: false,
				coEditing: {
					mode: "none", // Disable collaboration mode
				},
			},
		},
		token:
			"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkb2N1bWVudCI6eyJmaWxlVHlwZSI6ImRvY3giLCJrZXkiOiJ1bmlxdWUtZG9jLWtleSIsInRpdGxlIjoiU2FtcGxlIERvY3VtZW50LmRvY3giLCJ1cmwiOiJodHRwczovL3NjLWFkbWluLnJldmx2LmNvbS9zYW1wbGUuZG9jeCIsInBlcm1pc3Npb25zIjp7ImNoYXQiOmZhbHNlLCJjb21tZW50IjpmYWxzZX19LCJlZGl0b3JDb25maWciOnsibW9kZSI6ImVkaXQiLCJjYWxsYmFja1VybCI6Imh0dHBzOi8vc2MtZG9jc2VydmVyLnJldmx2LmNvbS9jYWxsYmFjayJ9LCJpYXQiOjE3MzczNzI1MDV9.p5AJtED-W_mzfSoqGLt7Iq7FGd2GqXcXhQtgEV7AJ2g",
	};

	return (
		<div style={{ height: "100vh" }}>
			<DocumentEditor
				id="onlyoffice-editor"
				documentServerUrl="https://sc-docserver.revlv.com" // Update with your document server URL
				config={config}
				width="100%"
				height="100%"
			/>
		</div>
	);
};

function Page() {
	return (
		<Content>
			<Header />
			<div className="flex flex-col w-full max-w-[1200px] p-6">
				<div className="flex flex-col w-full gap-3">
					<OnlyOfficeEditor />
				</div>
				{/*<FullCalendar plugins={[dayGridPlugin]} initialView="dayGridMonth" />*/}
			</div>
		</Content>
	);
}
